<div class="container-fluid admin-page profile-page">
    <header class="admin-page-header">
        <div>
            <h1>{{ 'My profile' | translate }}</h1>
            <p>{{ 'Update your account details and password.' | translate }}</p>
        </div>
    </header>

    <form #profileForm="ngForm" (ngSubmit)="saveProfile(profileForm)" class="profile-form">
        <div class="profile-grid">
            <section class="profile-panel">
                <div class="profile-panel-heading">
                    <i class="material-icons">person</i>
                    <div>
                        <h2>{{ 'Account details' | translate }}</h2>
                        <p>{{ 'Your username identifies the account and cannot be changed.' | translate }}</p>
                    </div>
                </div>

                <div class="profile-fields">
                    <label>
                        <span>{{ 'Username' | translate }}</span>
                        <input [(ngModel)]="username" autocomplete="username" name="username" readonly>
                    </label>
                    <label>
                        <span>{{ 'Name' | translate }}</span>
                        <input [(ngModel)]="name" [disabled]="isSaving" autocomplete="name"
                               maxlength="150" name="name" required>
                    </label>
                    <label>
                        <span>{{ 'Email' | translate }}</span>
                        <input [(ngModel)]="email" [disabled]="isSaving" autocomplete="email" email
                               maxlength="254" name="email" required type="email">
                    </label>
                </div>
            </section>

            <section class="profile-panel">
                <div class="profile-panel-heading">
                    <i class="material-icons">lock</i>
                    <div>
                        <h2>{{ 'Change password' | translate }}</h2>
                        <p>{{ 'Leave these fields empty to keep your current password.' | translate }}</p>
                    </div>
                </div>

                <div class="profile-fields">
                    <label>
                        <span>{{ 'Current password' | translate }}</span>
                        <input [(ngModel)]="currentPassword" [disabled]="isSaving"
                               autocomplete="current-password" name="currentPassword" type="password">
                    </label>
                    <label>
                        <span>{{ 'New password' | translate }}</span>
                        <input [(ngModel)]="newPassword" [disabled]="isSaving" minlength="12"
                               autocomplete="new-password" name="newPassword" type="password">
                        <small [class.invalid]="hasWeakNewPassword()" class="password-requirements">
                            {{ 'At least 12 characters, including uppercase, lowercase, a number and a special character.' | translate }}
                        </small>
                    </label>
                    <label>
                        <span>{{ 'Verify new password' | translate }}</span>
                        <input [(ngModel)]="newPasswordConfirmation" [disabled]="isSaving"
                               autocomplete="new-password" name="newPasswordConfirmation" type="password">
                    </label>
                </div>
            </section>
        </div>

        @if (successMessage !== '') {
            <div class="profile-message success" role="status">
                <i class="material-icons">check_circle</i>
                <span>{{ successMessage | translate }}</span>
            </div>
        }
        @if (errorMessage !== '') {
            <div class="profile-message error" role="alert">
                <i class="material-icons">error</i>
                <span>{{ errorMessage | translate }}</span>
            </div>
        }

        <div class="profile-actions">
            <button [disabled]="isSaving || profileForm.invalid || hasWeakNewPassword()" class="save-profile-button"
                    type="submit">
                <i [class.spinning]="isSaving" class="material-icons">
                    {{ isSaving ? 'refresh' : 'save' }}
                </i>
                <span>{{ (isSaving ? 'Saving...' : 'Save changes') | translate }}</span>
            </button>
        </div>
    </form>
</div>
